import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import BtnGoBack from "../../components/common/btnGoBack";
import Loadding from "../../components/common/loadding";
import ShowDoc from "../../components/common/showDoc";
import BtnDeleteDoc5 from "../../components/report/reportDoc3/btnDeleteDoc5";
import Doc5GenPdf from "../../components/report/reportDoc3/doc5GenPdf";
import TitleReport from "../../components/report/titleReport";
import BtnSendDoc5 from "../../components/send/doc3/btnSendDoc5";
import { BaseURL } from "../../constants/enum/baseURL.emum";
import doc3Service from "../../services/doc3.service";
import doc5Service from "../../services/doc5.service";
type ParamType = {
  sche: string;
  curri: string;
  doc3: string;
};
const ReportDoc5 = () => {
  const me = useSelector((state: any) => state.me);
  const Param = useParams<ParamType>();
  const [curriInfo, setCurri3Info] = useState<any>({});
  const [course, setCourse] = useState<any>({});
  const [doc3info, setDoc3info] = useState<any>({});
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      //ไปเช็คที่ตาราง doc3 ว่ามี sche / course นี้ยัง
      await doc3Service.getById(Number(Param.doc3)).then((res) => {
        setCurri3Info(res.data.course.owner);
        setCourse(res.data.course);
        setDoc3info(res.data);
        setStatus(false);
      });
    })();
  }, [Param.doc3]);
  const [doc5List, setDoc5List] = useState([]);
  useEffect(() => {
    (async () => {
      await doc5Service.getByDoc3(Number(Param.doc3)).then((res: any) => {
        setDoc5List(res.data);
      });
    })();
  }, [Param.doc3]);
  // console.log(doc3info);
  if (status) {
    return <Loadding />;
  }

  return (
    <>
      <div className="container">
        <TitleReport scheId={Number(Param.sche)} />
        <div className="row">
          <div className="col text-start">
            <h5>
              หลักสูตร {curriInfo.shortName}- {curriInfo.name} (
              {curriInfo.level})
            </h5>
            <p>
              รายวิชา ({course.courseCode}) {course.name}
            </p>
          </div>
        </div>
        <hr />
        <table className="table table-hover table-responsive">
          <thead className="table-dark">
            <tr>
              <th>กลุ่มเรียน</th>
              <th>อาจารย์ผู้สอน</th>
              <th>Handle</th>
            </tr>
          </thead>
          <tbody>
            {!(doc5List.length > 0) && (
              <tr>
                <th colSpan={4} className="text-danger">
                  <i className="bi bi-folder-x"></i> ไม่พบการส่งเอกสาร{" "}
                  {curriInfo.type === "tqf" ? "มคอ." : "อชว."}5 | R-2
                </th>
              </tr>
            )}
            {doc5List.map((doc5: any) => {
              // console.log(doc5.pathFile);

              return (
                <tr key={doc5.id}>
                  <td>{doc5.group}</td>
                  <td>{doc5.teacher}</td>
                  <td>
                    <ShowDoc
                      btnName={`${curriInfo.type === "tqf" ? "มคอ." : "อชว."}5 | R-2`}
                      url={`${BaseURL.BASE_URL}/upload/doc5/${doc5.pathFile}`}
                      sendBy={doc5.sendBy}
                    />{" "}
                    {(me.role === "Admin" ||
                      (-1 !== doc5.sendBy.indexOf(me.firstName) &&
                        -1 !==
                          doc5.sendBy.indexOf(me.lastName.substr(0, 5)))) && (
                      <BtnDeleteDoc5
                        id={doc5.id}
                        type={curriInfo.type === "tqf" ? "มคอ." : "อชว."}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Doc5GenPdf
          doc3={Number(Param.doc3)}
          type={curriInfo.type === "tqf" ? "มคอ." : "อชว."}
        />{" "}
        <BtnSendDoc5
          schedule={Param.sche}
          curri={doc3info.course.owner}
          course={{ course: doc3info.course }}
          teacher={doc3info.teacher}
          doc5={doc3info.doc5}
          doc3Id={doc3info.id}
        />
      </div>
      <BtnGoBack />
    </>
  );
};

export default ReportDoc5;
